import script from "./ProfileManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileManager.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileManager.vue?vue&type=style&index=0&id=29ff7be0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ff7be0"]])

export default __exports__